import { Injectable } from '@angular/core';
import { SalesforceNamespace } from 'datasource-service-lib';
import { IDataSourceApiService, IEntity } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IRecipientInfoService } from './irecipient-info.service';

type SalesforceRecipientEntityType = 'Contact' | 'User';

@Injectable({
  providedIn: 'root',
})
export class SalesforceRecipientInfoService implements IRecipientInfoService {
  private readonly dataSourceApiService: IDataSourceApiService;
  // Recipient entity types are intentionally hardcoded to Contact and User
  // because they are standard Salesforce objects with guaranteed Email fields.
  // Custom objects are not included as they may not have email fields required for recipients.
  private readonly entityTypes: SalesforceRecipientEntityType[] = ['Contact', 'User'];

  constructor(sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory) {
    this.dataSourceApiService = sharedServiceProviderServiceFactory.getServiceProviderService(SalesforceNamespace.name)
      .getDataSourceApiService();
  }

  getEntityTypes(): SalesforceRecipientEntityType[] {
    return this.entityTypes;
  }

  getEntityInfo(entity: IEntity): Observable<any> {
    return this.dataSourceApiService.get(entity, { fields: 'Name, Email, Title' }).pipe(
      map((data) => {
        return {
          name: data.Name,
          email: data.Email,
          role: data.Title,
        };
      })
    );
  }
}
